/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Dispatch, SetStateAction, useState } from "react";
import { Box, IconButton } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";

import IosSwitchMain from "../../components/iosSwitchMain";

import AddTagsModal from "../../Modals/addTagModal";
import {
  useChangeTagStatusMutation,
  useLazyDeleteTagsQuery,
} from "../../service/group&tags";
import { showError, showToast } from "../../constants/toasts";
import { ConfirmationModal } from "../../Modals/confirmationModal";

const TagTable = ({
  data,
  getTagsApi,
  selectedTag,
  selectedTagId,
  setSelectedTag,
  setSelectedTagId,
  groupId,
}: {
  data: any;
  setSelectedTag: any;
  selectedTag: any;
  setSelectedTagId: Dispatch<SetStateAction<string>>;
  getTagsApi: () => void;
  selectedTagId: string;
  groupId: string | undefined;
}) => {
  const label = { inputProps: { "aria-label": "Switch demo" } };
  const [deleteTag] = useLazyDeleteTagsQuery();
  const [tagStatus] = useChangeTagStatusMutation();
  const [openDelete, setOpenDelete] = useState(false);

  const columns: GridColDef[] = [
    {
      flex: 2,
      minWidth: 50,
      field: "id",
      headerName: "S.No",
      editable: false,
      sortable: false,
      renderCell: (params) => {
        const allRowIds = params.api.getAllRowIds();
        const index = allRowIds.indexOf(params.id);
        return (
          <Box display="flex" alignItems="center" gap={1} className="cursor_p">
            <span>{index + 1}</span>
          </Box>
        );
      },
    },

    {
      field: "name",
      headerName: "Tag Name",
      flex: 2,
      minWidth: 150,
      sortable: false,
      editable: false,
      renderCell: ({ row }) => {
        return (
          <Box display="flex" alignItems="center" gap={1} className="cursor_p">
            <span>{row?.name || "-"}</span>
          </Box>
        );
      },
    },

    {
      flex: 2,
      minWidth: 150,
      field: "status",
      headerName: "Status",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <IosSwitchMain
            checked={row?.isActive}
            onChange={() => changeGroupStatusApi(row?.id)}
          />
        );
      },
    },

    {
      minWidth: 130,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions v2">
            <Box>
              <IconButton
                onClick={() => {
                  setSelectedTag(row);
                  setSelectedTagId(row?.id);
                  setOpen(true);
                }}
              >
                <img src="/static/images/edit_icon.svg" alt="" />
              </IconButton>
            </Box>
            <Box>
              <IconButton
                onClick={() => {
                  setSelectedTagId(row?.id);
                  setOpenDelete(true);
                }}
              >
                <img src="/static/images/trash2_icon.svg" alt="" />
              </IconButton>
            </Box>
          </div>
        );
      },
    },
  ];
  let hidden = ["fullName"];

  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };

  const deleteTagApi = async () => {
    try {
      const response = await deleteTag({ id: selectedTagId }).unwrap();
      if (response.status === 200) {
        getTagsApi();
        showToast(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const changeGroupStatusApi = async (id: string) => {
    try {
      const response = await tagStatus({ id }).unwrap();
      if (response.status === 200) {
        getTagsApi();
        showToast(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns?.filter((item) => !hidden.includes(item.field))}
          rows={data}
        />
      </div>

      <AddTagsModal
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
        getTagsApi={getTagsApi}
        selectedTag={selectedTag}
        selectedTagId={selectedTagId}
        groupId={groupId}
      />
      <ConfirmationModal
        text={"Are you sure to delete this Tag?"}
        openModal={openDelete}
        setOpenModal={setOpenDelete}
        handleSubmit={deleteTagApi}
      />
    </>
  );
};

export default TagTable;
